import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [FlexLayoutModule, TranslatePipe],
  selector: 'iot-platform-ui-page-title-card',
  templateUrl: './page-title-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page-title-card.component.scss']
})
export class PageTitleCardComponent {
  label = input<string>();
}
